module.exports = __webpack_public_path__ + "static/rewards-card-lancer-del-006c960f952b4fd37ba3098d139af5ec.png";